import { FC, useCallback, useEffect, useState } from 'react'
import ExamApi from '../../../../infrastructure/api/ExamApi'
import { IExamModel } from '../../../../models/responses/ExamModel'
import { PagedResponseModel } from '../../../../models/responses/PagedResponseModel'
import { IPaginationFilter } from '../../../../models/requests/PaginationFilter'
import { GenericTable } from '../../../components/tables/GenericTable'
import { TableHelperButtons } from '../../../components/buttons/TableHelperButtons'
import { TableHelperButtonEnum } from '../../../enums/TableHelperButtonEnum'
import { IExamTypeModel } from '../../../../models/responses/ExamTypeModel'
import { ILevelModel } from '../../../../models/responses/LevelModel'
import LevelApi from '../../../../infrastructure/api/LevelApi'
import ExamTypeApi from '../../../../infrastructure/api/ExamTypeApi'

type Props = {
  onClickItem: (itemId: any, itemName: string, type: string) => void
  refresh: number
}

const ExamListModal: FC<Props> = ({ onClickItem, refresh }) => {
  const [exams, setExams] = useState<PagedResponseModel<IExamModel[]>>()
  const [pageNumber, setPageNumber] = useState(1)
  const [pageSize, setPageSize] = useState(10)
  const [searchText, setSearchText] = useState('')
  const [sort, setSort] = useState('title_asc')
  const [levels, setLevels] = useState<ILevelModel[]>([])
  const [examTypes, setExamTypes] = useState<IExamTypeModel[]>()

  const init = async () => {
    const paginationFilter: IPaginationFilter = {
      page: pageNumber,
      size: pageSize,
      orderBy: sort,
      search: searchText,
    }

    var response = await ExamApi.GetExams(paginationFilter)
    setExams(response.data)

    var responseLevels = await LevelApi.GetLevelDictionary()
    setLevels(responseLevels.data)

    var responseExamTypes = await ExamTypeApi.GetExamTypes({
      page: 1,
      size: 9999,
      orderBy: 'title_asc',
      search: '',
    })
    setExamTypes(responseExamTypes.data.items)
  };

  useEffect(() => {
    init()
  }, [refresh, pageNumber, pageSize, searchText, sort])

  return (
    <>
      <GenericTable
        title='Exams'
        data={exams?.items}
        currentTotalRecords={exams?.totalRecords!!}
        currentPageNumber={exams?.pageNumber!!}
        columns={[
          {
            label: '#',
            name: '#',
            options: {
              customBodyRenderLite: (dataIndex) => {
                return <>{(pageNumber - 1) * pageSize + ++dataIndex}</>
              },
              sort: false,
              viewColumns: false,
            },
          },
          {
            label: 'Title',
            name: 'title',
            options: {
              customBodyRender: (value) => {
                return <b>{value}</b>
              },
            },
          },
          {
            label: 'Exam Type',
            name: 'examTypeId',
            options: {
              filter: true,
              customBodyRender: (value) => {
                return <div className='d-flex align-items-center'>{examTypes?.find(i => i.id == value)?.title}</div>
              },
            },
          },
          {
            label: 'Level',
            name: 'levelId',
            options: {
              filter: true,
              customBodyRender: (value) => {
                return <div className='d-flex align-items-center'>{levels.find(i => i.id == value)?.name}</div>
              },
            },
          },
          {
            label: 'Is Visible',
            name: 'isVisible',
            options: {
              filter: false,
              customBodyRender: (value) => {
                return <div className='d-flex align-items-center'>{value == false ? "Hide" : "Visible"}</div>
              },
            },
          },
          {
            label: '#',
            name: 'Id',
            options: {
              customHeadLabelRender: (options) => {
                return (
                  <div className='d-flex justify-content-end flex-shrink-0'>{options.label}</div>
                )
              },
              customBodyRenderLite: (dataIndex) => {
                return (
                  <TableHelperButtons
                    itemId={exams?.items[dataIndex]?.id!!}
                    itemParam={exams?.items[dataIndex]?.title!!}
                    links={[
                      { type: 'edit', value: '/exam/exams/edit/' + exams?.items[dataIndex]?.id!! }
                    ]}
                    types={[TableHelperButtonEnum.Delete]}
                    onClickItem={onClickItem}
                  />
                )
              },
              filter: false,
              sort: false,
              viewColumns: false,
            },
          },
        ]}
        customOptions={{
          rowsPerPage: pageSize,
          customTableBodyFooterRender: (opts) => {
            return <div></div>
          },
        }}
        setPageNumber={setPageNumber}
        setPageSize={setPageSize}
        setSearchText={setSearchText}
        setSort={setSort}
      />
    </>
  )
}

export { ExamListModal }
